module.exports = __webpack_public_path__ + "img/logo_white.9be858bf.png";